import { useTranslation as useTranslationi18n } from 'react-i18next';
import { i18n } from '.';

export function useTranslation () { 
    const v = useTranslationi18n('common', { i18n });
    return v;
}
